import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useRef, useContext } from 'react';
import chroma from 'chroma-js';
const baseColors = [
    '#0072b2',
    '#d55e00',
    '#009e73',
    '#cc79a7',
    '#332288'
];
const DEFAULT_COLOR_COUNT = 100;
const ColorContext = createContext(undefined);
export const ColorContextProvider = ({ children }) => {
    const baseColorRef = useRef(0);
    const palettesRef = useRef({});
    const baseColorMap = useRef({});
    const colorTableRef = useRef({});
    const rotateColor = () => {
        return baseColorRef.current++ % baseColors.length;
    };
    const colorFor = (parentId, memberId, scalar) => {
        if (!colorTableRef.current[parentId]) {
            colorTableRef.current[parentId] = baseColors[rotateColor()];
        }
        const colorId = `${parentId}${memberId !== null && memberId !== void 0 ? memberId : ''}`;
        if (colorId === parentId) {
            return colorTableRef.current[parentId];
        }
        if (!colorTableRef.current[colorId]) {
            const baseColor = colorTableRef.current[parentId];
            const paletteEnd = chroma(baseColor)
                .set('lch.l', 80)
                .set('lch.c', 20);
            if (!palettesRef.current[parentId]) {
                const colors = chroma.scale([colorTableRef.current[parentId], paletteEnd])
                    .mode('lch')
                    .colors(scalar);
                palettesRef.current[parentId] = colors;
            }
            const r = new RegExp(`^${parentId}.+$`);
            const paletteIndex = Object.keys(Object.keys(colorTableRef.current).filter(k => r.test(k))).length;
            colorTableRef.current[colorId] = palettesRef.current[parentId][paletteIndex];
        }
        return colorTableRef.current[colorId];
    };
    const currentScheme = () => {
        return colorTableRef.current;
    };
    return (_jsx(ColorContext.Provider, { value: { colorFor, currentScheme }, children: children }));
};
export const useColorContext = () => {
    const context = useContext(ColorContext);
    if (context === undefined) {
        throw new Error('useColorContext must be used within a ColorContextProvider');
    }
    return context;
};
